import React from 'react'

export default function OfflinePage() {
  return (
    <div>
      you are offline bro
    </div>
  )
}
